import React from 'react';
import { useDispatch, useSelector } from 'react-redux'

import RadioComponent from 'pu-react/components/RadioComponent';
import Label from 'pu-react/components/Label';

import { changeStencilsType } from '../stencilSlice';

const StencilType = ({ label, required }) => {
  const dispatch = useDispatch();
  const {
    stencilsType,
  } = useSelector((state) => state.smtStencil);
  const onChange = (data) => dispatch(changeStencilsType(data))

  const items = Spree.stencils_info.map((stencil) => {
    return (
      <RadioComponent
        key={stencil.id}
        name="stencil_type"
        inputId={`stencil-type-${stencil.id}`}
        label={stencil.name}
        checked={stencilsType === stencil.slug}
        onChange={() => onChange(stencil.slug)} />

    )
  });
  return (
    <div className="form-group">
      <Label label={label} required={required} />
      {items}
    </div>
  );
}

StencilType.defaultProps = {
  label: 'Stencil Type',
  required: false,
}

export default StencilType;
